module.exports = __webpack_public_path__ + "img/g.50ecac56.jpg";